import { RateType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { noop } from 'lodash-es';
import { useCallback } from 'react';

import { InfiniteQuery, InfiniteQueryOption } from './constants';

const rateTypeFilterLabelKey = {
  [RateType.RATE_COMMISSION]: 'administration.rates.rate_commission',
  [RateType.RATE_FLAT_COMMISSION]: 'administration.rates.rate_flat_commission',
  [RateType.RATE_FLAT_RATE]: 'administration.rates.rate_flat_rate',
  [RateType.RATE_PER_BUSHEL]: 'administration.rates.rate_per_bushel',
  [RateType.RATE_PER_DAY]: 'administration.rates.rate_per_day',
  [RateType.RATE_PER_EACH]: 'administration.rates.rate_per_each',
  [RateType.RATE_PER_HOUR]: 'administration.rates.rate_per_hour',
  [RateType.RATE_PER_LOAD]: 'administration.rates.rate_per_load',
  [RateType.RATE_PER_POUND]: 'administration.rates.rate_per_pound',
  [RateType.RATE_PER_TON]: 'administration.rates.rate_per_ton',
  [RateType.RATE_PER_TONNE]: 'administration.rates.rate_per_tonne',
  [RateType.RATE_PER_YARD]: 'administration.rates.rate_per_yard',
} satisfies Record<RateType, string>;

const data: InfiniteQueryOption[] = Object.entries(rateTypeFilterLabelKey).map(
  ([rateType, labelKey]) => ({
    label: t(labelKey),
    value: rateType,
  }),
);

export default function useRateTypesInfiniteQuery(): InfiniteQuery {
  const noopFn = useCallback(() => {
    return noop;
  }, []);

  return {
    clear: noopFn,
    data,
    fetch: noopFn,
    fetchMore: undefined,
    isDummyQuery: true,
  };
}
